module.exports = __webpack_public_path__ + "static/IMG_8324_mobile-8ea9e7f60baec23b3e1ca84284253acc.jpg";